import axiosInstance from "../../api/axiosConfig";

export const getOrders = () => {
  return axiosInstance.get("/orders");
};
